module.exports = "https://cdn.hellotech.com/client-assets/printers_mobile_7c9fda36b2884966aa669f1d350dae5c.png";